















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SelectBoolean extends Vue {
  @Prop({ default: 'label' })
  label: string | undefined;

  validateColor: string = '';
  invalidateColor: string = '';

  validate() {
    this.validateColor = '#4CAF50';
    this.invalidateColor = '';
    this.$emit('input', true);
  }

  invalidate() {
    this.invalidateColor = '#FF9800';
    this.validateColor = '';
    this.$emit('input', false);
  }
}
